import { normalizeComponentResource } from '@/utils/component-resources'
export const COMPONENT_RESOURCE_DRAG_TYPE = 'application/x-ironman-component-resource'
let dragging = null
export function beginComponentResourceDrag (item) {
  const value = normalizeComponentResource(item)
  const key = Date.now().toString(36) + '-' + Math.random().toString(36).slice(2)
  dragging = { key, value }
  return key
}
export function endComponentResourceDrag () { dragging = null }
export function componentResourceFromDrag (key) {
  const current = dragging; dragging = null
  return current && current.key === key ? JSON.parse(JSON.stringify(current.value)) : null
}
